<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="waterwayPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panels"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panels" multiple color="#fff">
      <v-expansion-panel value="waterwayConditions" class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('waterwayConditions')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Waterway Conditions</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="validWaterwayConditions" ref="modifyWaterwayConditions">
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  showDurationIcon
                  id="select_Scour_Critical"
                  label="WA.01 SCBI"
                  :refTable="REFERENCE_TABLE.SCOUR_CRITICAL_BRIDGE_INDICATOR"
                  :isEditable="isEditable && scbiSource == 'C'"
                  :isRequired="isEditable && scbiSource == 'C'"
                  v-model="scourCritical"
                  :tooltip="
                    getHistDuration(
                      structure?.inspectionConditionHist?.scourCriticalDuration,
                      structure?.inspectionConditionHist?.scourCriticalDurationChanges,
                    )
                  "
                  @update:modelValue="
                    {
                      scbiUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                ></LabelSelect>
                <LabelSelect
                  style="padding-top: 3px"
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Scour_Critical_Category"
                  label="WA.02 Scour Critical Category"
                  :isEditable="false"
                  v-model="scourCriticalCategory"
                  :refTable="REFERENCE_TABLE.SCOUR_CRITICAL_CATEGORY"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_scbi_Source"
                  label="WA.03 SCBI Source"
                  :refTable="REFERENCE_TABLE.SCOUR_CRITICAL_BRIDGE_INDICATOR_SOURCE"
                  :isEditable="isEditable"
                  :isRequired="isEditable"
                  v-model="scbiSource"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Overall_SCBI"
                  label="WA.04 Overall SCBI"
                  :isEditable="false"
                  v-model="overallScbi"
                  :refTable="REFERENCE_TABLE.SCOUR_CRITICAL_BRIDGE_INDICATOR"
                ></LabelSelect>
                <v-row>
                  <v-col xl="5" lg="6" md="5" sm="6" cols="6" class="pt-1 px-0 pb-0">
                    <v-row>
                      <v-col class="pa-0">
                        <v-btn
                          cols="9"
                          id="btn_calculate"
                          variant="outlined"
                          class="mx-4"
                          @click="calculate"
                          :disabled="!isEditable"
                          >Calculate</v-btn
                        ></v-col
                      >
                      <v-col cols="3" class="px-0 pb-0 pt-2">
                        <v-label class="bold"><span>WA.05:</span></v-label>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col xl="6" lg="5" md="4" sm="3" cols="3" style="padding-top: 6px">
                    <v-row>
                      <v-col class="d-flex pa-0">
                        <v-checkbox
                          class="pl-3 pt-1"
                          id="checkbox_Calculate_No_Grid"
                          aria-describedby="checkbox_Calculate_No_Grid"
                          aria-labelledby="checkbox_Calculate_Label"
                          true-value="1"
                          hide-details
                          :disabled="true"
                          v-model="scourCalculated"
                          ><template v-slot:label>
                            <div
                              id="checkbox_Calculate_Label"
                              aria-describedby="checkbox_Calculate_Label"
                              aria-label="checkbox_Calculate_Label"
                              for="checkbox_Calculate_No_Grid"
                              v-show="false"
                            >
                              WA.05 Checkbox label
                            </div>
                          </template></v-checkbox
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Channel"
                  label="B.C.09 Channel"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="channel"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(
                      structure?.inspectionConditionHist?.chanRatingDuration,
                      structure?.inspectionConditionHist?.chanRatingDurationChanges,
                    )
                  "
                  @update:modelValue="
                    {
                      channelConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="selected_Channel_Protection"
                  label="B.C.10 Channel Protection"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="channelProtectionRating"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Overall_Scour"
                  label="B.C.11 Overall Scour"
                  :refTable="REFERENCE_TABLE.SCOUR_CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="overallScourHole"
                  @update:modelValue="inspectionStore.setOverallScourHoleChangedByUser(true)"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  :isRequired="isEditable ? true : false"
                  id="select_Underwater"
                  label="B.C.15 Underwater"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  v-model="underwater"
                  @update:modelValue="underwaterChangedByUser = true"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_substructure_nav_protection"
                  label="B.N.06 Substructure Nav Protection"
                  :refTable="REFERENCE_TABLE.PIER_PROTECTION"
                  :isRequired="isEditable && waterwayValue.navCntrol == 'Y' ? true : false"
                  :isEditable="isEditable"
                  v-model="pierProtection"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="selected_Scour_Vulnerability"
                  label="B.AP.03 Scour Vulnerability"
                  :refTable="REFERENCE_TABLE.SCOUR_VULNERABILITY"
                  :isEditable="false"
                  v-model="scourVulnerability"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="scour_poa_required"
                  label="B.AP.04 Scour Plan of Action Required"
                  :refTable="REFERENCE_TABLE.SCOUR_POA_REQUIRED"
                  v-model="waterwayValue.scpoaReqD"
                ></LabelSelect>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="waterwayDetails">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('waterwayDetails')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Waterway Details</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="validWaterwayDetails" ref="modifyWaterwayDetails">
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="6"
                  :labelSm="6"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Stream_Bed_Material_1"
                  label="WA.06 Stream Bed Material"
                  :refTable="REFERENCE_TABLE.STREAM_BED_MATERIAL"
                  :isEditable="isEditable"
                  v-model="streamBedMaterialOne"
                ></LabelSelect>
              </v-col>
              <v-col v-if="$vuetify.display.mdAndDown" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelMd="4"
                  :labelSm="5"
                  :selectMd="6"
                  :selectSm="6"
                  label=" "
                  :showColon="false"
                  id="select_Stream_Bed_Material_2"
                  :refTable="REFERENCE_TABLE.STREAM_BED_MATERIAL"
                  :isEditable="isEditable"
                  v-model="streamBedMaterialTwo"
                ></LabelSelect>
              </v-col>
              <v-col v-else cols="4">
                <LabelSelect
                  :selectXl="12"
                  :selectLg="12"
                  id="select_Stream_Bed_Material_2"
                  :refTable="REFERENCE_TABLE.STREAM_BED_MATERIAL"
                  :isEditable="isEditable"
                  v-model="streamBedMaterialTwo"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <LabelText
                  dense
                  :labelXl="12"
                  :labelLg="12"
                  :labelMd="12"
                  :labelSm="12"
                  :textXl="12"
                  :textLg="12"
                  :textMd="12"
                  :textSm="12"
                  type="textarea"
                  label="WA.07 Streambed Material Description"
                  id="text_Stream_Bed_Material_Description"
                  v-model="streamBedMaterialDescription"
                  :isEditable="isEditable"
                  :counter="streambedMaterialMaxLength"
                  :maxlength="streambedMaterialMaxLength"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelText
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :textXl="2"
                  :textLg="2"
                  :textMd="2"
                  :textSm="3"
                  textStyle="width: 100%"
                  type="number"
                  maxlength="2"
                  id="text_Number_Of_Subunits"
                  label="WA.08 Number of Subunits"
                  :rules="
                    isEditable
                      ? [
                          (value) => {
                            return lessThanValueRule(value, 99);
                          },
                        ]
                      : []
                  "
                  :isEditable="isEditable"
                  v-model="numberOfSubunits"
                />
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Nab_Location"
                  label="WA.09 NAB Location"
                  :refTable="REFERENCE_TABLE.ABUTMENT_LOCATION"
                  :isEditable="isEditable"
                  v-model="nabLoaction"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Fab_Location"
                  label="WA.10 FAB Location"
                  :refTable="REFERENCE_TABLE.ABUTMENT_LOCATION"
                  :isEditable="isEditable"
                  v-model="fabLoaction"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Us_Left_Presence"
                  label="WA.11 U/S Left WW Presence"
                  :refTable="REFERENCE_TABLE.WINGWALL_PRESENCE"
                  :isEditable="isEditable"
                  v-model="leftPresence"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Left_Condition"
                  label="WA.12 U/S Left Condition"
                  :refTable="REFERENCE_TABLE.UPSTREAM_WINGWALL_CONDITION"
                  :isEditable="isEditable"
                  v-model="leftCondition"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Right_Presence"
                  label="WA.13 U/S Right WW Presence"
                  :refTable="REFERENCE_TABLE.WINGWALL_PRESENCE"
                  :isEditable="isEditable"
                  v-model="rightPresence"
                ></LabelSelect>
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="4"
                  :labelSm="5"
                  :selectXl="6"
                  :selectLg="5"
                  :selectMd="6"
                  :selectSm="5"
                  id="select_Right_Condition"
                  label="WA.14 U/S Right Condition"
                  :refTable="REFERENCE_TABLE.UPSTREAM_WINGWALL_CONDITION"
                  :isEditable="isEditable"
                  v-model="rightCondition"
                ></LabelSelect>
              </v-col>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelText
                  :labelXl="5"
                  :labelLg="4"
                  :labelMd="4"
                  :labelSm="5"
                  :textXl="2"
                  :textLg="2"
                  :textMd="2"
                  :textSm="2"
                  textStyle="width: 100%"
                  type="number"
                  id="text_Horiz_Debris_Start"
                  label="WA.15 Horizontal Debris Start"
                  :isEditable="isEditable"
                  v-model="horizDebrisStart"
                  :showComma="false"
                  maxlength="3"
                  max="100"
                  min="0"
                  :decimalPlaces="0"
                  :style="isEditable ? '' : 'padding-top: 2px'"
                  :alignRight="isEditable ? true : false"
                />
                <LabelText
                  :labelXl="5"
                  :labelLg="4"
                  :labelMd="4"
                  :labelSm="5"
                  :textXl="2"
                  :textLg="2"
                  :textMd="2"
                  :textSm="2"
                  afterText="(0%=LAB to 100%=RAB)"
                  type="number"
                  id="text_Horiz_Debris_End"
                  label="WA.16 Horizontal Debris End"
                  :isEditable="isEditable"
                  v-model="horizDebrisEnd"
                  textStyle="width: 100%"
                  :showComma="false"
                  :decimalPlaces="0"
                  maxlength="3"
                  max="100"
                  min="0"
                  :style="isEditable ? '' : 'padding-top: 2px'"
                  :alignRight="isEditable ? true : false"
                />
                <LabelText
                  :labelXl="5"
                  :labelLg="4"
                  :labelMd="4"
                  :labelSm="5"
                  :textXl="2"
                  :textLg="2"
                  :textMd="2"
                  :textSm="2"
                  type="number"
                  textStyle="width: 100%"
                  id="text_Vert_Debris_Start"
                  label="WA.17 Vertical Debris Start"
                  :isEditable="isEditable"
                  v-model="vertDebrisStart"
                  :showComma="false"
                  :decimalPlaces="0"
                  maxlength="3"
                  max="100"
                  min="0"
                  :style="isEditable ? '' : 'padding-top: 2px'"
                  :alignRight="isEditable ? true : false"
                />
                <LabelText
                  :labelXl="5"
                  :labelLg="4"
                  :labelMd="4"
                  :labelSm="5"
                  :textXl="2"
                  :textLg="2"
                  :textMd="2"
                  :textSm="2"
                  afterText="(0%=Streambed to 100%=Beam)"
                  type="number"
                  id="text_Vert_Debris_End"
                  label="WA.18 Vertical Debris End"
                  textStyle="width: 100%"
                  :isEditable="isEditable"
                  v-model="vertDebrisEnd"
                  :showComma="false"
                  :decimalPlaces="0"
                  maxlength="3"
                  max="100"
                  min="0"
                  :style="isEditable ? '' : 'padding-top: 2px'"
                  :alignRight="isEditable ? true : false"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="measuresAndCountermeasures" @group:selected="checkCurrentScourValidation">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('measuresAndCountermeasures')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Current Scour Measures and Countermeasures</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="!isEditable || anyEditableCurrent"
                id="btn_addDetails"
                variant="outlined"
                class="my-2 ml-3"
                @click="addCurrent()"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="mb-8">
            <v-col cols="12">
              <v-data-table
                class="noScrollTable compactTable"
                :items="measuresCurrent"
                :headers="measuresCurrentHeaders"
                v-model:expanded="expandedRowsCurrent"
                hide-default-footer
                :items-per-page="-1"
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.cMeasureType`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.cMeasureLocation`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.cMeasureCond`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.pierNum`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.Action`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:item="{ item }">
                  <tr :class="rowClassCurrent(item)">
                    <td class="text-center">
                      <template v-if="!anyEditableCurrent">
                        <button v-if="!isExpandedCurrent(item)" @click="toggleCurrentRow(item)">
                          <v-icon
                            :id="`icon_Chevron_Right_${item.UNIQUE_KEY}`"
                            icon="fa-solid fa-chevron-right"
                          ></v-icon>
                        </button>

                        <button v-if="isExpandedCurrent(item)" @click="toggleCurrentRow(item)">
                          <v-icon :id="`icon_Chevron_Down_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-down"></v-icon>
                        </button>
                      </template>
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.cMeasureType
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.CURRENT_COUNTERMEASURE_TYPE,
                              item?.cMeasureType,
                              false,
                            )
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.cMeasureLocation
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.CURRENT_COUNTERMEASURE_LOCATION,
                              item?.cMeasureLocation,
                              false,
                            )
                          : ""
                      }}
                    </td>

                    <td class="alignCenter">
                      {{
                        item?.cMeasureCond
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.CURRENT_COUNTERMEASURE_CONDITION,
                              item?.cMeasureCond,
                              false,
                            )
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.pierNum
                          ? item.pierNum +
                            "-" +
                            inspectionStore.getSubStructure(item.pierNum, waterwayValue.structureUnits)?.strUnitLabel
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      <div style="white-space: nowrap" v-if="!item.readOnly && isEditable">
                        <IconTooltip
                          id="icon_Current_Update"
                          icon="fa-solid fa-check"
                          :tooltip="item.isAdd ? 'Add' : 'Update'"
                          @click="saveCurrent(item)"
                        />
                        <IconTooltip
                          id="icon_Current_Close"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeCurrent"
                        />
                      </div>
                      <div style="white-space: nowrap" v-else-if="isEditable && !anyEditableCurrent">
                        <IconTooltip
                          id="icon_Current_Edit"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editCurrent(item)"
                        />
                        <IconTooltip
                          id="icon_Current_Delete"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteCurrent(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="measuresCurrentHeaders.length">
                    <v-form ref="currentForm" v-model="validCurrent" class="mt-2">
                      <v-row
                        ><v-col cols="6" class="pl-3 pt-3">
                          <LabelText
                            labelXl="4"
                            labelLg="4"
                            labelMd="6"
                            labelSm="6"
                            textXl="6"
                            textLg="6"
                            textMd="6"
                            textSm="6"
                            id="currentNum"
                            label="WA.19 Record Key"
                            v-model="item.UNIQUE_KEY"
                            type="number"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pl-3">
                          <LabelSelect
                            labelXl="4"
                            labelLg="4"
                            labelMd="6"
                            labelSm="6"
                            selectXl="6"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="currentType"
                            label="WA.20 Type"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.cMeasureType"
                            :refTable="REFERENCE_TABLE.CURRENT_COUNTERMEASURE_TYPE"
                            @update:modelValue="
                              {
                                changesDetectedCurrent = true;
                              }
                            "
                          />
                        </v-col>
                        <v-col cols="6">
                          <LabelSelect
                            labelXl="4"
                            labelLg="4"
                            labelMd="6"
                            labelSm="6"
                            selectXl="6"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="currentCondition"
                            label="WA.22 Condition"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.cMeasureCond"
                            :refTable="REFERENCE_TABLE.CURRENT_COUNTERMEASURE_CONDITION"
                            @update:modelValue="
                              {
                                changesDetectedCurrent = true;
                              }
                            "
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pl-3">
                          <LabelSelect
                            labelXl="4"
                            labelLg="4"
                            labelMd="6"
                            labelSm="6"
                            selectXl="6"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="currentLocation"
                            label="WA.21 Location"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.cMeasureLocation"
                            :options="cMeasureLocations"
                            @update:modelValue="
                              {
                                changesDetectedCurrent = true;
                              }
                            "
                          />
                        </v-col>
                        <v-col cols="6">
                          <LabelSelect
                            labelXl="4"
                            labelLg="4"
                            labelMd="6"
                            labelSm="6"
                            selectXl="6"
                            selectLg="6"
                            selectMd="6"
                            selectSm="6"
                            id="currentSubunit"
                            label="WA.23 Subunit"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.pierNum"
                            :options="subUnits"
                            :isRequired="isEditable && !item.readOnly"
                            @update:modelValue="
                              {
                                changesDetectedCurrent = true;
                              }
                            "
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </td>
                </template>
                <template v-slot:bottom> </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="potentialCountermeasures">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('potentialCountermeasures')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Potential Countermeasures</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="!isEditable || anyEditablePotential"
                id="btn_addPotential"
                variant="outlined"
                class="my-2 ml-3"
                @click="addPotential()"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="mb-8">
            <v-col cols="12">
              <v-data-table
                class="noScrollTable compactTable"
                :items="measuresPotential"
                :headers="potentialHeaders"
                v-model:expanded="expandedRowsPotential"
                hide-default-footer
                :items-per-page="-1"
                show-expand
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.location`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.wcKey`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:[`header.Action`]="{ column }">
                  <DataTableHeader :column="column" :lines="2" />
                </template>
                <template v-slot:item="{ item }">
                  <tr :class="rowClassPotential(item)">
                    <td class="text-center">
                      <template v-if="!anyEditablePotential">
                        <button v-if="!isExpandedPotential(item)" @click="togglePotentialRow(item)">
                          <v-icon
                            :id="`icon_Chevron_Right_${item.UNIQUE_KEY}`"
                            icon="fa-solid fa-chevron-right"
                          ></v-icon>
                        </button>

                        <button v-if="isExpandedPotential(item)" @click="togglePotentialRow(item)">
                          <v-icon :id="`icon_Chevron_Down_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-down"></v-icon>
                        </button>
                      </template>
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.location
                          ? configStore.getReferenceValue(
                              REFERENCE_TABLE.CURRENT_COUNTERMEASURE_LOCATION,
                              item?.location,
                              false,
                            )
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      {{
                        item?.wcKey
                          ? configStore.getReferenceValue(REFERENCE_TABLE.WORK_CANDIDATE, item?.wcKey, false)
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      <div
                        style="white-space: nowrap"
                        v-if="isExpandedPotential(item) && anyEditablePotential && isEditable"
                      >
                        <IconTooltip
                          id="icon_add"
                          icon="fa-solid fa-check"
                          :tooltip="item?.isAdd ? 'Add' : 'Update'"
                          @click="savePotential(item)"
                        />
                        <IconTooltip id="icon_close" icon="fa-solid fa-xmark" tooltip="Close" @click="closePotential" />
                      </div>
                      <div style="white-space: nowrap" v-else-if="isEditable && !anyEditablePotential">
                        <IconTooltip
                          id="icon_edit"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editPotential(item)"
                        />
                        <IconTooltip
                          id="icon_delete"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deletePotential(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="potentialHeaders.length">
                    <v-row
                      ><v-col xl="8" lg="9" md="10" sm="12" cols="12" class="pl-3 pt-3">
                        <LabelText
                          labelXl="5"
                          labelLg="5"
                          labelMd="5"
                          labelSm="5"
                          textXl="7"
                          textLg="7"
                          textMd="7"
                          textSm="7"
                          id="potentialNum"
                          label="WA.24 Record Key"
                          v-model="item.UNIQUE_KEY"
                          type="number"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xl="8" lg="9" md="10" sm="12" cols="12" class="pl-3">
                        <LabelSelect
                          labelXl="5"
                          labelLg="5"
                          labelMd="5"
                          labelSm="5"
                          selectXl="7"
                          selectLg="7"
                          selectMd="7"
                          selectSm="7"
                          id="potentialLocation"
                          label="WA.25 Location"
                          :isEditable="isEditable && !item.readOnly"
                          v-model="item.location"
                          :options="cMeasureLocations"
                          @update:modelValue="
                            {
                              changesDetectedPotential = true;
                            }
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xl="8" lg="9" md="10" sm="12" cols="12" class="pl-3">
                        <LabelSelect
                          labelXl="5"
                          labelLg="5"
                          labelMd="5"
                          labelSm="5"
                          selectXl="7"
                          selectLg="7"
                          selectMd="7"
                          selectSm="7"
                          id="potentialCountermeasures"
                          label="WA.26 Countermeasures"
                          :isEditable="isEditable && !item.readOnly"
                          v-model="item.wcKey"
                          :refTable="REFERENCE_TABLE.WORK_CANDIDATE"
                          @update:modelValue="
                            {
                              changesDetectedPotential = true;
                            }
                          "
                        />
                      </v-col>
                    </v-row>
                  </td>
                </template>
                <template v-slot:bottom> </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="500yrFloodPlain" @group:selected="checkFloodPlainFormValidation">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('500yrFloodPlain')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Subunits within 500yr Flood Plain</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-row>
            <v-col class="px-0">
              <v-btn
                :disabled="
                  !isEditable ||
                  anyEditableFloodPlain ||
                  inspectionStore.getIDsNotInUnderwaterInsp(waterwayValue).length == 0
                "
                id="btn_addFloodPlain"
                variant="outlined"
                class="my-2 ml-3"
                @click="addFloodPlain()"
                >Add Subunit</v-btn
              >
              <v-tooltip v-if="inspectionStore?.getIDsNotInUnderwaterInsp(waterwayValue).length == 0">
                <template v-slot:activator="{ props }">
                  <v-icon
                    id="icon_AddSubunitInfo"
                    class="my-1 ml-3 mr-2 infoIcon"
                    icon="fas fa-circle-info"
                    v-bind="props"
                  />
                </template>
                <div>
                  <span>No Subunits available to Add.</span>
                </div>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row class="mb-8">
            <v-col cols="12">
              <v-data-table
                ref="floodPlainTable"
                class="lessPaddingTableColumns"
                :items="floodPlains"
                :headers="floodPlainHeaders"
                v-model:expanded="expandedRowsFloodPlain"
                hide-default-footer
                show-expand
                :items-per-page="-1"
                v-model:sort-by="sortByFloodPlain"
                must-sort
                return-object
              >
                <template v-slot:[`header.data-table-expand`]="{ column }">
                  {{ column.title }}
                </template>
                <template v-slot:[`header.subUnit`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.obsScourRating`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.scourHole`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.foundType`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.streamBedMaterial`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.underwaterInspType`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.uwRequired`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.maxWaterDepth`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.scbiCode`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:[`header.Action`]="{ column }">
                  <DataTableHeader :column="column" :sortBy="sortByFloodPlain" />
                </template>
                <template v-slot:item="{ item }">
                  <tr :class="rowClassFloodPlain(item)">
                    <td class="text-center">
                      <template v-if="!anyEditableFloodPlain">
                        <button v-if="!isExpandedFloodPlain(item)" @click="toggleFloodPlainsRow(item)">
                          <v-icon
                            :id="`icon_Chevron_Right_${item.UNIQUE_KEY}`"
                            icon="fa-solid fa-chevron-right"
                          ></v-icon>
                        </button>

                        <button v-if="isExpandedFloodPlain(item)" @click="toggleFloodPlainsRow(item)">
                          <v-icon :id="`icon_Chevron_Down_${item.UNIQUE_KEY}`" icon="fa-solid fa-chevron-down"></v-icon>
                        </button>
                      </template>
                    </td>
                    <td class="alignCenter">
                      {{ item?.subUnit }}
                    </td>
                    <td class="alignCenter">
                      {{ item?.obsScourRating }}
                    </td>
                    <td class="alignCenter">
                      {{ item?.scourHole }}
                    </td>
                    <td class="alignCenter">
                      {{
                        item.foundType
                          ? configStore.getReferenceValue(REFERENCE_TABLE.OSA_FOUNDATION_TYPE, item.foundType)
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      {{
                        item.streamBedMaterial
                          ? configStore.getReferenceValue(REFERENCE_TABLE.STREAM_BED_MATERIAL, item.streamBedMaterial)
                          : ""
                      }}
                    </td>
                    <td class="alignCenter">
                      {{ item?.underwaterInspType }}
                    </td>
                    <td>
                      <v-row>
                        <v-col xl="4" lg="3" md="1" sm="1" cols="1" class="pl-0" />
                        <v-col class="pl-0">
                          <v-checkbox
                            v-if="!item?.isAdd"
                            class="alignCenter"
                            id="checkbox_UW_INSP__TYPE"
                            hide-details
                            :true-value="'1'"
                            disabled
                            v-model="getIsUwRequired(item).isUwRequired"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </td>
                    <td class="alignCenter">
                      {{ item?.maxWaterDepth }}
                    </td>
                    <td class="alignCenter">
                      {{ item.scbiCode != "" ? item.scbiCode : "--" }}
                    </td>
                    <td class="alignCenter">
                      <div
                        style="white-space: nowrap"
                        v-if="isExpandedFloodPlain(item) && anyEditableFloodPlain && isEditable"
                      >
                        <IconTooltip
                          id="floodplain_icon_add"
                          icon="fa-solid fa-check"
                          :tooltip="item?.isAdd ? 'Add' : 'Update'"
                          @click="saveFloodPlain(item)"
                        />
                        <IconTooltip
                          id="floodplain_icon_close"
                          icon="fa-solid fa-xmark"
                          tooltip="Close"
                          @click="closeFloodPlain(item)"
                        />
                      </div>
                      <div style="white-space: nowrap" v-else-if="isEditableForAnyServTypUnd && !anyEditableFloodPlain">
                        <IconTooltip
                          v-if="isEditable"
                          id="floodplain_icon_edit"
                          icon="fa-solid fa-pencil"
                          tooltip="Edit"
                          @click="editFloodPlain(item)"
                        />
                        <IconTooltip
                          v-if="isEditableForAnyServTypUnd"
                          id="floodplain_icon_delete"
                          icon="fa-solid fa-trash"
                          tooltip="Delete"
                          @click="deleteFloodPlain(item)"
                        />
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-row="{ item }">
                  <td :colspan="floodPlainHeaders.length">
                    <v-form v-model="validFloodPlain" ref="floodPlainForm">
                      <v-row>
                        <v-col xl="6" lg="6" md="12" sm="12" cols="12" class="pl-3 pt-3">
                          <v-row v-if="!item?.isAdd">
                            <v-col xl="5" lg="6" md="5" sm="6" cols="6" class="pb-0">
                              <v-label class="bold pb-0">WA.27 Sub Unit:</v-label>
                            </v-col>
                            <v-col xl="6" lg="5" md="7" sm="6" cols="6" class="pb-0">
                              <span class="pl-4 pb-0">{{
                                inspectionStore.getSubStructure(item?.strUnitKey, waterwayValue.structureUnits)
                                  .strUnitKey +
                                "-" +
                                inspectionStore.getSubStructure(item?.strUnitKey, waterwayValue.structureUnits)
                                  .strUnitLabel
                              }}</span>
                            </v-col>
                          </v-row>
                          <LabelSelect
                            v-else
                            class="pt-2 pb-0"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="select_Sub_Unit_Id"
                            label="WA.27 Sub Unit"
                            :options="inspectionStore.getIDsNotInUnderwaterInsp(waterwayValue)"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.strUnitKey"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelCheckbox
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            class="labelCheckbox"
                            id="is_current"
                            label="WA.28 Current Inspection?"
                            :showColon="false"
                            editIndent
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.previousCurrent"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          >
                          </LabelCheckbox>
                          <v-row>
                            <v-col xl="5" lg="6" md="5" sm="6" cols="6" class="mt-1 pt-1 d-flex">
                              <v-label class="bold">WA.29 SCBI Code:</v-label>
                            </v-col>
                            <v-col xl="6" lg="5" md="6" sm="5" cols="5" class="mt-1 pt-1 d-flex">
                              <span class="pl-4">{{ item.scbiCode != "" ? item.scbiCode : "--" }}</span>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col xl="5" lg="6" md="5" sm="6" cols="6" class="pt-2 mt-1 d-flex">
                              <v-label class="bold">WA.30 SCBI Case:</v-label>
                            </v-col>
                            <v-col xl="6" lg="5" md="6" sm="5" cols="5" class="pt-2 mt-1 d-flex">
                              <span class="pl-4">{{ item.scbiCase != "" ? item.scbiCase : "--" }}</span>
                            </v-col>
                          </v-row>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="scour_rating"
                            label="WA.31 Scour Rating"
                            :refTable="REFERENCE_TABLE.OBSERVED_SCOUR_RATING"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.obsScourRating"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="change_since_last_insp"
                            label="WA.32 Change Since Last Insp"
                            :refTable="REFERENCE_TABLE.CHANGE_SINCE_LAST_INSP"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.changeSinceLastInsp"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="scour_hole"
                            label="WA.33 Scour hole"
                            :refTable="REFERENCE_TABLE.SCOUR_HOLE"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.scourHole"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="debris_potn"
                            label="WA.34 Debris Potential"
                            :refTable="REFERENCE_TABLE.DEBRIS_POTENTIAL"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.debrisPotential"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="scourability"
                            label="WA.35 Scourability"
                            :refTable="REFERENCE_TABLE.SUBSTRUCTURE_SCOURABILITY"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.subScour"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="opening_adeq_channel"
                            label="WA.36 Opening Adeq Channel"
                            :refTable="REFERENCE_TABLE.OPENING_ADEQUACY_CHANNEL"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.openAdeqChannel"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="seidment"
                            label="WA.37 Sediment"
                            :refTable="REFERENCE_TABLE.SEDIMENT_DEPOSITS"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.sedDeposit"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="alignment"
                            label="WA.38 Alignment"
                            :refTable="REFERENCE_TABLE.ALIGNMENT"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.alignment"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="velocity_stream_slope"
                            label="WA.39 Velocity Stream Slope"
                            :refTable="REFERENCE_TABLE.VELOCITY_STREAM_SLOPE"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.veloStreamSlope"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                        </v-col>
                        <v-col
                          xl="6"
                          lg="6"
                          md="12"
                          sm="12"
                          cols="12"
                          :class="$vuetify.display.mdAndDown ? 'pb-0 pl-3' : 'pb-0'"
                        >
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="subunit_Type"
                            label="WA.40 Pier/Abutment Type"
                            :options="getPierAbutTypes(item.legacyStructureType)"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.subUnitType"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="inv_found_type"
                            label="WA.41 Inv Foundation Type"
                            :refTable="REFERENCE_TABLE.PA_FOUNDATION_TYPE"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.invFoundType"
                            @update:modelValue="
                              if (item.invFoundType == 'A') {
                                item.foundType = '1';
                              } else if (['R', 'K', 'L'].includes(item.invFoundType)) {
                                item.foundType = '2';
                              } else if (
                                ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'S'].includes(item.invFoundType)
                              ) {
                                item.foundType = '3';
                              } else if (item.invFoundType == 'O') {
                                item.foundType = '4';
                              } else if (['P', 'X'].includes(item.invFoundType)) {
                                item.foundType = '5';
                              }
                              item.changesDetectedFloodPlain = true;
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            id="found_type"
                            :isEditable="false"
                            :refTable="REFERENCE_TABLE.OSA_FOUNDATION_TYPE"
                            label="WA.42 OSA Foundation Type"
                            v-model="item.foundType"
                          >
                          </LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="streambed_material"
                            label="WA.43 Streambed Material"
                            :refTable="REFERENCE_TABLE.STREAM_BED_MATERIAL"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.streamBedMaterial"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelSelect
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="uw_insp_type"
                            label="WA.44 UW Inspection Type"
                            :refTable="REFERENCE_TABLE.UNDERWATER_INSPECTION_TYPE"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.underwaterInspType"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          ></LabelSelect>
                          <LabelText
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="ob_scour_depth"
                            :type="'number'"
                            appendWith=" ft"
                            :decimalPlaces="1"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            :isEditable="isEditable && !item.readOnly"
                            label="WA.45 Observed Scour Depth"
                            maxlength="4"
                            v-model="item.obsScourDepth"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0.0, 99.9);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            :isRequired="isEditable && !item.readOnly"
                            id="max_water_depth"
                            :type="'number'"
                            appendWith=" ft"
                            :decimalPlaces="1"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            :isEditable="isEditable && !item.readOnly"
                            label="WA.46 Water Depth"
                            maxlength="4"
                            v-model="item.maxWaterDepth"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0.0, 99.0);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelCheckbox
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            id="movement"
                            label="WA.47 Movement Indicator"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.movement"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          >
                          </LabelCheckbox>
                          <LabelCheckbox
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            id="scour_undermine_ind"
                            label="WA.48 Scour/Undermine Indicator"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.scourUndermine"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          >
                          </LabelCheckbox>
                          <LabelCheckbox
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :selectXl="6"
                            :selectLg="5"
                            :selectMd="7"
                            :selectSm="6"
                            id="countermeasures"
                            label="WA.49 Countermeasures"
                            :isEditable="isEditable && !item.readOnly"
                            v-model="item.counterMeasure"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          >
                          </LabelCheckbox>
                          <LabelText
                            class="pt-1"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :textXl="6"
                            :textLg="5"
                            :textMd="7"
                            :textSm="6"
                            id="onehundred_year_flood_depth"
                            :type="'number'"
                            appendWith=" ft"
                            :decimalPlaces="1"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            :isEditable="isEditable && !item.readOnly"
                            :showPlaceholder="true"
                            label="WA.50 100 YR Flood Scour Depth"
                            maxlength="4"
                            v-model="item.calcScourDepth100"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0.0, 99.9);
                                    },
                                  ]
                                : []
                            "
                          />
                          <LabelText
                            class="pt-2"
                            :labelXl="5"
                            :labelLg="6"
                            :labelMd="5"
                            :labelSm="6"
                            :textXl="6"
                            :textLg="5"
                            :textMd="7"
                            :textSm="6"
                            id="fivehundred_year_flood_depth"
                            :type="'number'"
                            appendWith=" ft"
                            :decimalPlaces="1"
                            :roundingFactor="ROUNDING_FACTOR.TENTH"
                            maxlength="4"
                            :isEditable="isEditable && !item.readOnly"
                            :showPlaceholder="true"
                            label="WA.51 500 YR Flood Scour Depth"
                            v-model="item.calcScourDepth500"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                            :rules="
                              isEditable
                                ? [
                                    (value) => {
                                      return valueInRangeRule(value, 0.0, 99.9);
                                    },
                                  ]
                                : []
                            "
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pl-3 pt-2">
                          <LabelText
                            class="pt-0"
                            :labelXl="12"
                            :labelLg="12"
                            :labelMd="12"
                            :labelSm="12"
                            :textXl="12"
                            :textLg="12"
                            :textMd="12"
                            :textSm="12"
                            id="textarea_notes"
                            v-model="item.underwaterInspDesc"
                            :isEditable="isEditable && !item.readOnly"
                            :counter="commentsMaxLength"
                            :maxlength="commentsMaxLength"
                            label="WA.53 Notes"
                            persistent-counter
                            type="textarea"
                            auto-grow
                            rows="1"
                            @update:modelValue="
                              {
                                item.changesDetectedFloodPlain = true;
                              }
                            "
                          >
                          </LabelText>
                        </v-col>
                      </v-row>
                    </v-form>
                  </td>
                </template>
                <template v-slot:bottom> </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="adequacyInfo">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('adequacyInfo')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Channel and Waterway Adequacy Information</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-form v-model="validChannelAndWaterwayAdequacyInfo" ref="modifyChannelAndWaterwayAdequacyInfo">
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  v-if="$vuetify.display.mdAndDown"
                  :labelMd="5"
                  :labelSm="6"
                  id="select_Channel_Rating"
                  label="B.C.09 Channel"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="false"
                  v-model="channelRating"
                ></LabelSelect>
                <LabelSelect
                  v-else
                  noGrid
                  id="select_Channel_Rating"
                  label="B.C.09 Channel"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="false"
                  v-model="channelRating"
                ></LabelSelect>
              </v-col>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  v-if="$vuetify.display.mdAndDown"
                  :labelMd="5"
                  :labelSm="6"
                  id="select_Channel_Protection"
                  label="B.C.10 Channel Protection"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="false"
                  v-model="channelProtectionRating"
                ></LabelSelect>
                <LabelSelect
                  v-else
                  noGrid
                  id="select_Channel_Protection"
                  label="B.C.10 Channel Protection"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="false"
                  v-model="channelProtectionRating"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Channel"
                  id="field_Channel_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.CHANNEL"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Channel"
                  id="field_Channel_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.CHANNEL"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.CHANNEL)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Channel Protection"
                  id="field_Channel_Protection_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.CHANNEL_PROTECTION"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Channel Protection"
                  id="field_Channel_Protection_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.CHANNEL_PROTECTION"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.CHANNEL_PROTECTION)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Banks"
                  id="field_Banks_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.BANKS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Banks"
                  id="field_Banks_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.BANKS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.BANKS)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Streambed Movements"
                  id="field_Streambed_Movements_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.STREAMBED_MOVEMENTS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Streambed Movements"
                  id="field_Streambed_Movements_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.STREAMBED_MOVEMENTS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.STREAMBED_MOVEMENTS)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Debris, Vegetation"
                  id="field_Debris_Vegetation_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.DEBRIS_VEGITATION"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Debris, Vegetation"
                  id="field_Debris_Vegetation_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.DEBRIS_VEGITATION"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.DEBRIS_VEGITATION)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="River (Stream) Control Devices"
                  id="field_River_Control_Devices_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.RIVER_CONTROL_DEVICES"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="River (Stream) Control Devices"
                  id="field_River_Control_Devices_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.RIVER_CONTROL_DEVICES"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.RIVER_CONTROL_DEVICES)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Embankment/Streambed Controls"
                  id="field_Embankment_Streambed_Controls_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.EMBANKMENT_STREAMBED_CONTROLS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Embankment/Streambed Controls"
                  id="field_Embankment_Streambed_Controls_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.EMBANKMENT_STREAMBED_CONTROLS"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="
                    (comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.EMBANKMENT_STREAMBED_CONTROLS)
                  "
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Drift, Other"
                  id="field_Drift_Other_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.DRIFT_OTHER"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Drift, Other"
                  id="field_Drift_Other_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.DRIFT_OTHER"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.DRIFT_OTHER)"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="12">
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="Waterway Adequacy"
                  id="field_Waterway_Adequacy_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.WATERWAY_ADEQUACY"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="Waterway Adequacy"
                  id="field_Waterway_Adequacy_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.WATERWAY_ADEQUACY"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.WATERWAY_ADEQUACY)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="5"
                  :selectLg="4"
                  :selectMd="5"
                  :selectSm="4"
                  id="select_Overtopping_Likelihood"
                  label="B.AP.02 Overtopping Likelihood"
                  :refTable="REFERENCE_TABLE.OVERTOPPING_RISK"
                  :isEditable="isEditable"
                  v-model="riskOfOvertopping"
                ></LabelSelect>
              </v-col>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="5"
                  :selectLg="4"
                  :selectMd="5"
                  :selectSm="4"
                  id="select_Traffic_Delay"
                  label="WA.54 Traffic Delay"
                  :refTable="REFERENCE_TABLE.TRAFFIC_DELAY"
                  :isEditable="isEditable"
                  v-model="trafficDelay"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="5"
                  :selectLg="4"
                  :selectMd="5"
                  :selectSm="4"
                  id="select_Worst_Flood_Event"
                  label="WA.55 Worst Flood Event"
                  :refTable="REFERENCE_TABLE.WORST_FLOOD_EVENT"
                  :isEditable="isEditable"
                  v-model="worstFloodEvent"
                ></LabelSelect>
              </v-col>

              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelDatefield
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :textXl="5"
                  :textLg="4"
                  :textMd="5"
                  :textSm="4"
                  id="text_Worst_Flood_Event_Date"
                  label="WA.56 Worst Flood Event Date"
                  v-model="worstFloodEventDate"
                  :isEditable="isEditable"
                >
                </LabelDatefield>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="6" lg="6" md="12" sm="12" cols="12">
                <LabelSelect
                  :labelXl="5"
                  :labelLg="6"
                  :labelMd="5"
                  :labelSm="6"
                  :selectXl="5"
                  :selectLg="4"
                  :selectMd="5"
                  :selectSm="4"
                  id="select_Functional_Class"
                  label="B.H.01 Functional Class"
                  :refTable="REFERENCE_TABLE.ROADWAY_FUNCTIONAL_CLASSIFICATION"
                  :isEditable="false"
                  v-model="functionClass"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col xl="4" lg="4" md="12" sm="12" cols="12">
                <LabelText
                  v-if="$vuetify.display.mdAndDown"
                  :labelMd="5"
                  :labelSm="6"
                  :isEditable="isEditable"
                  id="number_Elevation_Of_Water_Level"
                  label="WA.57 High Water Elevation"
                  :allowCommas="false"
                  v-model="elevationOfWaterLevel"
                  type="number"
                  maxlength="4"
                  appendWith=" ft"
                >
                </LabelText>
                <LabelText
                  v-else
                  noGrid
                  :isEditable="isEditable"
                  id="number_Elevation_Of_Water_Level"
                  label="WA.57 High Water Elevation"
                  :allowCommas="false"
                  v-model="elevationOfWaterLevel"
                  type="number"
                  maxlength="4"
                  appendWith=" ft"
                >
                </LabelText>
              </v-col>
              <v-col xl="4" lg="4" md="12" sm="12" cols="12" class="pt-1">
                <LabelDatefield
                  v-if="$vuetify.display.mdAndDown"
                  :labelMd="5"
                  :labelSm="6"
                  addLabelPadding
                  addDatePadding
                  id="text_High_Water_Date"
                  label="WA.58 High Water Date"
                  :isEditable="isEditable"
                  v-model="highWaterDate"
                >
                </LabelDatefield>
                <LabelDatefield
                  v-else
                  :labelLg="6"
                  :labelXl="5"
                  :textXl="6"
                  :textLg="6"
                  addLabelPadding
                  addDatePadding
                  id="text_High_Water_Date"
                  label="WA.58 High Water Date"
                  :isEditable="isEditable"
                  v-model="highWaterDate"
                >
                </LabelDatefield>
              </v-col>
              <v-col xl="4" lg="4" md="12" sm="12" cols="12">
                <LabelCheckbox
                  v-if="$vuetify.display.mdAndDown"
                  :labelMd="5"
                  :labelSm="6"
                  class="waterwayCheckbox"
                  label="WA.59 New High Water Mark"
                  :id="'checkbox_New_High_Water_Mark'"
                  v-model="newHighWaterMark"
                  :isEditable="isEditable"
                >
                </LabelCheckbox>
                <LabelCheckbox
                  v-else
                  noGrid
                  class="waterwayCheckbox"
                  label="WA.59 New High Water Mark"
                  :id="'checkbox_New_High_Water_Mark'"
                  v-model="newHighWaterMark"
                  :isEditable="isEditable"
                >
                </LabelCheckbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <CommentTypeTextField
                  v-if="moduleType == MODULE_TYPES.INSPECTION"
                  label="WA.60 High Water Notes"
                  id="field_High_Water_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.HIGH_WATER_MARK"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  @changesDetected="inspectionStore.setDirtyFlag(true)"
                />
                <ManagementCommentTypeTextField
                  v-else
                  label="WA.60 High Water Notes"
                  id="field_High_Water_Notes"
                  :inspectionCommentType="INSPECTION_COMMENTS.HIGH_WATER_MARK"
                  :readonly="!isEditable"
                  :counter="commentsMaxLength"
                  :maxlength="commentsMaxLength"
                  :comments="waterwayValue.inspectionComments"
                  :brkey="waterwayValue.brkey"
                  :inspectionId="waterwayValue.inspectionId"
                  @updateComment="(comment) => setUpdatedComment(comment, INSPECTION_COMMENTS.HIGH_WATER_MARK)"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <ConfirmDialog ref="confirm" :cancelButtonText="BUTTONS.NO" />
  </v-row>
</template>
<script>
import { computed, ref, watch, onMounted, nextTick } from "vue";
import { clone } from "@/util/clone";
import { ENV_CONFIG_PROPERTY, CONFIG_SORT_BY } from "@/constants/EnvConfigProperties";
import { SORT_ORDER, TYPES, BUTTONS } from "@/constants/CommonWebConstants";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import CommentTypeTextField from "@/components/common/CommentTypeTextField.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import IconTooltip from "@/components/common/IconTooltip.vue";
import { INSPECTION_MESSAGES, MODULE_TYPES } from "@/constants/InspectionConstants";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { LOGGER } from "@/util/logger";
import { UNDERWATER_INSP } from "@/data/underwaterInspection";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";
import LabelDatefield from "@/components/common/LabelDatefield.vue";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import { getHistDuration } from "@/composables/util";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { useSnackbarStore } from "@/stores/snackbar";
import { getNextKey } from "@/util/generateKey.js";
import { getScourPOA } from "@/composables/waterways.js";
import { floodPlainCustomSort } from "@/composables/featuresWaterway";
import { sortByTwoProperties } from "@/util/sortStructure.js";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar.js";
import { useWaterwayStore } from "@/components/inspection/store/waterway";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import ManagementCommentTypeTextField from "@/components/common/ManagementCommentTypeTextField.vue";
import { lessThanValueRule, valueInRangeRule } from "@/composables/validationRules";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { useUserPermissionStore } from "@/stores/userPermission";
import { INSPECTION_LINKS_WATERWAY_PERMISSIONS, ACCESS_LEVELS } from "@/rbac";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";

export default {
  name: "WaterwayComponent",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  data() {
    return {
      measuresCurrentHeaders: [
        { key: "data-table-expand" },

        {
          line1: "WA.20",
          line2: "Type",
          line3: null,
          sortable: false,
          key: "cMeasureType",
        },
        {
          line1: "WA.21",
          line2: "Location",
          line3: null,
          sortable: false,
          key: "cMeasureLocation",
        },
        {
          line1: "WA.22",
          line2: "Condition",
          line3: null,
          sortable: false,
          key: "cMeasureCond",
        },
        {
          line1: "WA.23",
          line2: "Subunit",
          line3: null,
          sortable: false,
          key: "pierNum",
        },
        {
          line1: null,
          line2: "Action",
          line3: null,
          sortable: false,
          key: "Action",
        },
      ],
      potentialHeaders: [
        { title: "", key: "data-table-expand" },
        {
          line1: "WA.25",
          line2: "Location",
          line3: null,
          sortable: false,
          key: "location",
        },
        {
          line1: "WA.26",
          line2: "Countermeasures",
          line3: null,
          sortable: false,
          key: "wcKey",
        },
        {
          line1: null,
          line2: "Action",
          line3: null,
          sortable: false,
          key: "Action",
        },
      ],
      floodPlainHeaders: [
        {
          line1: null,
          line2: null,
          line3: null,
          key: "data-table-expand",
          width: "3%",
        },
        {
          line1: "WA.27",
          line2: "Subunit",
          line3: null,
          sortable: true,
          key: "subUnit",
          width: "9%",
          sortRaw: floodPlainCustomSort,
        },
        {
          line1: "WA.31",
          line2: "OBS Scour",
          line3: "Rating",
          sortable: true,
          key: "obsScourRating",
        },
        {
          title: "WA.33 Scour Hole",
          line1: "WA.33",
          line2: "Scour",
          line3: "Hole",
          sortable: true,
          key: "scourHole",
        },
        {
          line1: "WA.42",
          line2: "OSA Foundation",
          line3: "Type",
          sortable: true,
          key: "foundType",
        },
        {
          line1: "WA.43",
          line2: "Streambed",
          line3: "Material",
          sortable: true,
          key: "streamBedMaterial",
        },
        {
          line1: "WA.44",
          line2: "UW Insp",
          line3: "Type",
          sortable: true,
          key: "underwaterInspType",
        },
        {
          line1: null,
          line2: "Is UW",
          line3: "Req'd?",
          sortable: false,
          key: "uwRequired",
        },
        {
          line1: "WA.46",
          line2: "Water",
          line3: "Depth (ft)",
          sortable: true,
          key: "maxWaterDepth",
        },
        {
          line1: "WA.29",
          line2: "SCBI",
          line3: "Code",
          sortable: true,
          key: "scbiCode",
        },
        {
          line1: null,
          line2: "Action",
          line3: null,
          sortable: false,
          key: "Action",
          width: "5%",
        },
      ],
    };
  },
  setup(props) {
    const configStore = useConfigStore();
    const snackbarStore = useSnackbarStore();
    const inspectionStore = useInspectionStore();
    const waterwayStore = useWaterwayStore();
    const quickSearchStore = useQuickSearchStore();
    const inspectionLinksStore = useInspectionLinksStore();

    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const userPermissionStore = useUserPermissionStore();
    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_WATERWAY_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(waterwayValue.value.brkey),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_WATERWAY_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(waterwayValue.value.brkey),
          );
        }
      },
    });
    let validationSnackbar = computed({
      get() {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          return inspectionLinksStore.showValidationSnackbar;
        } else {
          return inspectionStore.getShowValidationSnackbar;
        }
      },
      set(value) {
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          inspectionLinksStore.showValidationSnackbar = value;
        } else {
          inspectionStore.setShowValidationSnackbar(value);
        }
      },
    });
    const setAddingOrEditing = (value) => {
      if (props.moduleType == MODULE_TYPES.INSPECTION) {
        inspectionStore.setAddingOrEditing(value);
      } else if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
        inspectionLinksStore.isAddingOrEditingWaterway = value;
      }
    };
    const isEditable = computed(() => {
      const servTypUnd = Number.parseInt(waterwayValue.value?.servTypUnd);
      if (servTypUnd >= 5 && servTypUnd <= 9) {
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          return inspectionStore.isEditable;
        } else {
          return !quickSearchStore.getErrorMessage() && waterwayValue.value?.brkey && hasAccessToEdit.value;
        }
      } else {
        return false;
      }
    });
    const isEditableForAnyServTypUnd = computed(() => {
      if (props.moduleType == MODULE_TYPES.INSPECTION) {
        return inspectionStore.isEditable;
      } else {
        return !quickSearchStore.getErrorMessage() && waterwayValue.value?.brkey && hasAccessToEdit.value;
      }
    });
    let waterwayValue = ref({});
    let resetDirty = ref(false);
    let currentSnackbarId = ref("");
    let potentialSnackbarId = ref("");
    let floodPlainSnackbarId = ref("");
    let structure = computed(() => inspectionStore.selectedInspection);
    const allPanels = [
      "waterwayConditions",
      "waterwayDetails",
      "measuresAndCountermeasures",
      "potentialCountermeasures",
      "500yrFloodPlain",
      "adequacyInfo",
    ];
    const panels = ref(allPanels);

    const DELETE_CONFIRM_UNDERWATER_INSP = "Are you sure you want to delete this Subunit from the 500yr Flood Plain?";
    const DELETE_CONFIRM_POTENTIAL = "Are you sure you want to delete this Potential Countermeasure?";
    const DELETE_CONFIRM_CURRENT = "Are you sure you want to delete this Current Countermeasure?";

    const commentsMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.INSPECTION_COMMENT_MAX_LENGTH);
    });

    const streambedMaterialMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.ELEM_DESC_MAX_LENGTH);
    });

    let sortByFloodPlain = ref([{ key: "subUnit", order: "asc" }]);

    function getSortIcon(id) {
      const item = sortByFloodPlain.value.find((item) => item.key === id);
      if (item) {
        return item.order === "asc"
          ? { isSorted: true, sortType: "fa-sort-up" }
          : { isSorted: true, sortType: "fa-sort-down" };
      } else {
        return { isSorted: false, sortType: "fa-sort-up" };
      }
    }

    const subUnits = computed(() => {
      return inspectionStore.getSubUnits(waterwayValue.value.structureUnits);
    });

    const getPierAbutTypes = (legacyStructureType) => {
      if (legacyStructureType == "B") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value <= 10);
      } else if (legacyStructureType == "P") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value >= 21);
      } else if (legacyStructureType == "C") {
        return configStore
          .getReferenceValues(
            REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
            CONFIG_SORT_BY.VALUE,
            SORT_ORDER.ASC,
            false,
            TYPES.NUMBER,
          )
          ?.filter((pierAbutType) => pierAbutType.value == 10 || pierAbutType.value == 2);
      } else {
        return configStore.getReferenceValues(
          REFERENCE_TABLE.PIER_ABUTMENT_TYPE,
          CONFIG_SORT_BY.VALUE,
          SORT_ORDER.ASC,
          false,
          TYPES.NUMBER,
        );
      }
    };

    const cMeasureLocations = computed(() => {
      return configStore.getReferenceValues(
        REFERENCE_TABLE.CURRENT_COUNTERMEASURE_LOCATION,
        CONFIG_SORT_BY.VALUE,
        SORT_ORDER.ASC,
        false,
        TYPES.NUMBER,
      );
    });

    //Waterway Conditions Code

    let validWaterwayConditions = ref(true);
    let validWaterwayDetails = ref(true);
    let validChannelAndWaterwayAdequacyInfo = ref(true);
    let valid = ref(true);

    let modifyWaterwayConditions = ref(null);
    let modifyWaterwayDetails = ref(null);
    let modifyChannelAndWaterwayAdequacyInfo = ref(null);

    const readData = async () => {
      resetChangedByUser();
      waterwayValue.value = {};
      resetDirty.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        await waterwayStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );
        waterwayValue.value = waterwayStore.getWaterwayObject();
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        await waterwayStore.loadDataObject(props.moduleType, null, null, structure.value);
        waterwayValue.value = waterwayStore.getWaterwayObject();
      }
      resetDirty.value = true;
      getFloodPlains();
      getMeasuresCurrent();
      getMeasuresPotential();
      await validate();
    };
    onMounted(async () => {
      await readData();
    });

    const scourCritical = computed({
      get() {
        return waterwayValue.value?.scourCritical;
      },
      set(scourCriticalParam) {
        waterwayValue.value.scourCritical = scourCriticalParam;
      },
    });

    const scourCriticalCategory = computed({
      get() {
        if (!waterwayValue.value?.scourCriticalCat || waterwayValue.value?.scourCriticalCat == "") {
          return "--";
        } else {
          return waterwayValue.value?.scourCriticalCat;
        }
      },
    });

    let underwaterChangedByUser = ref(false);

    const underwater = computed({
      get() {
        if (!waterwayValue.value?.underwaterRating && !underwaterChangedByUser.value) {
          if (waterwayValue.value?.subRating < waterwayValue.value?.culvRating) {
            return waterwayValue.value?.subRating;
          } else {
            return waterwayValue.value?.culvRating;
          }
        } else {
          return waterwayValue.value?.underwaterRating;
        }
      },
      set(underwaterParam) {
        waterwayValue.value.underwaterRating = underwaterParam;
      },
    });

    const scbiSource = computed({
      get() {
        return waterwayValue.value?.scbiSource;
      },
      set(scbiSourceParam) {
        waterwayValue.value.scbiSource = scbiSourceParam;
      },
    });

    const overallScbi = computed({
      get() {
        return waterwayValue.value?.overallOSA;
      },
      set(overallScbiParam) {
        waterwayValue.value.overallOSA = overallScbiParam;
      },
    });

    const scourCalculated = computed({
      get() {
        return waterwayValue.value?.scourCalculated;
      },
      set(scourCalculatedParam) {
        waterwayValue.value.scourCalculated = scourCalculatedParam;
      },
    });
    const overallScourHole = computed({
      get() {
        return inspectionStore.getOverallScourHole(waterwayValue.value.scourCondRating, null, waterwayValue.value);
      },
      set(overallScourParam) {
        waterwayValue.value.scourCondRating = overallScourParam;
      },
    });
    const scourVulnerability = computed({
      get() {
        return waterwayValue.value?.scourVulnerability;
      },
    });

    const channel = computed({
      get() {
        return waterwayValue.value?.chanRating;
      },
      set(channelParam) {
        waterwayValue.value.chanRating = channelParam;
      },
    });

    const pierProtection = computed({
      get() {
        return waterwayValue.value?.pierprot;
      },
      set(pierprot) {
        waterwayValue.value.pierprot = pierprot;
      },
    });

    const channelProtectionRating = computed({
      get() {
        return waterwayValue.value?.chanProtRating;
      },
      set(channelProtectionRatingParam) {
        waterwayValue.value.chanProtRating = channelProtectionRatingParam;
      },
    });

    //Waterway Details Code

    const streamBedMaterialOne = computed({
      get() {
        return waterwayValue.value?.streamBedMaterial1;
      },
      set(streamBedMaterialOneParam) {
        waterwayValue.value.streamBedMaterial1 = streamBedMaterialOneParam;
      },
    });

    const streamBedMaterialTwo = computed({
      get() {
        return waterwayValue.value?.streamBedMaterial2;
      },
      set(streamBedMaterialTwoParam) {
        waterwayValue.value.streamBedMaterial2 = streamBedMaterialTwoParam;
      },
    });

    const streamBedMaterialDescription = computed({
      get() {
        return waterwayValue.value?.streamBedMaterialDesc;
      },
      set(streamBedMaterialDescriptionParam) {
        waterwayValue.value.streamBedMaterialDesc = streamBedMaterialDescriptionParam;
      },
    });

    const numberOfSubunits = computed({
      get() {
        return waterwayValue.value?.unitsInspectedQty;
      },
      set(numberOfSubunitsParam) {
        waterwayValue.value.unitsInspectedQty = numberOfSubunitsParam;
      },
    });

    const horizDebrisStart = computed({
      get() {
        return waterwayValue.value?.horDebrisStartPct;
      },
      set(horizDebrisStartParam) {
        waterwayValue.value.horDebrisStartPct = horizDebrisStartParam;
      },
    });

    const horizDebrisEnd = computed({
      get() {
        return waterwayValue.value?.horDebrisEndPct;
      },
      set(horizDebrisEndParam) {
        waterwayValue.value.horDebrisEndPct = horizDebrisEndParam;
      },
    });

    const vertDebrisStart = computed({
      get() {
        return waterwayValue.value?.vertDebrisStartPct;
      },
      set(vertDebrisStartParam) {
        waterwayValue.value.vertDebrisStartPct = vertDebrisStartParam;
      },
    });

    const vertDebrisEnd = computed({
      get() {
        return waterwayValue.value?.vertDebrisEndPct;
      },
      set(vertDebrisEndParam) {
        waterwayValue.value.vertDebrisEndPct = vertDebrisEndParam;
      },
    });

    const fabLoaction = computed({
      get() {
        return waterwayValue.value?.fabLocation;
      },
      set(fabLoactionParam) {
        waterwayValue.value.fabLocation = fabLoactionParam;
      },
    });

    const nabLoaction = computed({
      get() {
        return waterwayValue.value?.nabLocation;
      },
      set(nabLoactionParam) {
        waterwayValue.value.nabLocation = nabLoactionParam;
      },
    });

    const leftPresence = computed({
      get() {
        return waterwayValue.value?.usLeftWWPresence;
      },
      set(leftPresenceParam) {
        waterwayValue.value.usLeftWWPresence = leftPresenceParam;
      },
    });
    const leftCondition = computed({
      get() {
        return waterwayValue.value?.usLeftWWCond;
      },
      set(leftConditionParam) {
        waterwayValue.value.usLeftWWCond = leftConditionParam;
      },
    });
    const rightPresence = computed({
      get() {
        return waterwayValue.value?.usRightWWPresence;
      },
      set(rightPresenceParam) {
        waterwayValue.value.usRightWWPresence = rightPresenceParam;
      },
    });
    const rightCondition = computed({
      get() {
        return waterwayValue.value?.usRightWWCond;
      },
      set(rightConditionParam) {
        waterwayValue.value.usRightWWCond = rightConditionParam;
      },
    });

    //common table Code

    const onRowExpand = (event) => {
      //on clicking on row expansion icon - set the data to readonly.
      event.data.readOnly = true;
    };

    const confirm = ref(null);

    //Current Scour Measures and Countermeasures Code

    let currentForm = ref(null);

    let validCurrent = ref(false);

    let expandedRowsCurrent = ref([]);

    let changesDetectedCurrent = ref(false);

    let measuresCurrent = ref([]);

    const getNewCurrent = () => {
      return {
        brkey: waterwayValue.value.brkey,
        cMeasureCond: "",
        cMeasureKey: getNextKey(waterwayValue.value.scourCMeasures, "cMeasureKey"),
        cMeasureLocation: "",
        cMeasureType: "",
        inspectionId: waterwayValue.value.inspectionId,
        pierNum: null,
      };
    };

    const convertToCurrentObject = (detail) => {
      return {
        brkey: detail.brkey,
        cMeasureCond: detail.cMeasureCond,
        cMeasureKey: detail.cMeasureKey,
        cMeasureLocation: detail.cMeasureLocation,
        cMeasureType: detail.cMeasureType,
        inspectionId: detail.inspectionId,
        pierNum: detail.pierNum,
      };
    };

    const getMeasuresCurrent = () => {
      expandedRowsCurrent.value = [];
      measuresCurrent.value = clone(waterwayValue.value.scourCMeasures);

      if (!measuresCurrent?.value?.[0]) {
        //remove null values from array(if any)
        measuresCurrent.value = measuresCurrent.value?.filter((a) => !!a);
      }
      sortByTwoProperties(measuresCurrent.value, "cMeasureLocation", "pierNum");
      for (let idx = 1; idx <= measuresCurrent.value?.length; idx++) {
        measuresCurrent.value[idx - 1].UNIQUE_KEY = idx;
        measuresCurrent.value[idx - 1].readOnly = true;
      }
    };

    const rowClassCurrent = (data) => {
      return expandedRowsCurrent.value?.find((a) => a.UNIQUE_KEY === data.UNIQUE_KEY) ? "rowSelect" : "rowUnselect";
    };

    const closeCurrent = () => {
      if (isEditable.value && changesDetectedCurrent.value) {
        //show confirmation dialog on closing
        confirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              getMeasuresCurrent();
              expandedRowsCurrent.value = [];
              changesDetectedCurrent.value = false;
              setAddingOrEditing(false);
              snackbarStore.removeMessage(currentSnackbarId.value);
            }
          });
      } else {
        getMeasuresCurrent();
        expandedRowsCurrent.value = [];
        setAddingOrEditing(false);
        snackbarStore.removeMessage(currentSnackbarId.value);
      }
    };

    const isExpandedCurrent = (details) => {
      return expandedRowsCurrent.value?.findIndex((a) => a.UNIQUE_KEY == details.UNIQUE_KEY) >= 0;
    };

    function editCurrent(detail) {
      setAddingOrEditing(true);
      detail.readOnly = false;
      expandedRowsCurrent.value = [detail];
      currentSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.CURRENT_SCOUR_MEASURES_AND_COUNTERMEASURES_DATATABLE,
      });
    }

    function deleteCurrent(detail) {
      confirm.value.open(DELETE_CONFIRM_CURRENT, BUTTONS.YES).then((response) => {
        if (response) {
          const deleteIndex = waterwayValue.value.scourCMeasures.findIndex(
            (a) => a?.cMeasureKey === detail.cMeasureKey,
          );
          if (deleteIndex > -1) {
            waterwayValue.value.scourCMeasures.splice(deleteIndex, 1);
            expandedRowsCurrent.value = [];
            getMeasuresCurrent();
          }
        }
      });
    }

    const anyEditableCurrent = computed(() => {
      return expandedRowsCurrent.value?.some((element) => !element.readOnly);
    });

    const toggleCurrentRow = (detail) => {
      if (expandedRowsCurrent.value?.includes(detail)) {
        const index = expandedRowsCurrent.value.findIndex((a) => detail.UNIQUE_KEY == a.UNIQUE_KEY);
        expandedRowsCurrent.value.splice(index, 1);
      } else {
        expandedRowsCurrent.value.push(detail);
      }
    };

    function addCurrent() {
      setAddingOrEditing(true);
      currentSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.CURRENT_SCOUR_MEASURES_AND_COUNTERMEASURES_DATATABLE,
      });
      let newCurrent = getNewCurrent();
      newCurrent.isAdd = true;
      newCurrent.readOnly = false;
      newCurrent.UNIQUE_KEY = getNextKey(measuresCurrent.value, "UNIQUE_KEY");
      measuresCurrent.value.unshift(newCurrent);
      expandedRowsCurrent.value = [newCurrent];
      nextTick(() => {
        currentForm.value.validate();
      });
    }

    function saveCurrent(detail) {
      currentForm.value
        .validate()
        .then(() => {
          if (validCurrent.value) {
            validationSnackbar.value = false;
            snackbarStore.removeMessage(currentSnackbarId.value);
            if (!waterwayValue.value?.scourCMeasures?.[0]) {
              //remove null values from array(if any)
              waterwayValue.value.scourCMeasures = waterwayValue.value.scourCMeasures?.filter((a) => !!a);
            }
            if (detail.isAdd) {
              waterwayValue.value.scourCMeasures.push(convertToCurrentObject(detail));
            } else {
              //update existing
              const updateIndex = waterwayValue.value.scourCMeasures.findIndex(
                (a) => a?.cMeasureKey === detail.cMeasureKey,
              );
              waterwayValue.value.scourCMeasures.splice(updateIndex, 1, convertToCurrentObject(detail));
            }
            //if all required fields entered - close the expanded row
            expandedRowsCurrent.value = [];
            getMeasuresCurrent();
            changesDetectedCurrent.value = false;
            setAddingOrEditing(false);
          } else {
            validationSnackbar.value = true;
          }
        })
        .catch((err) => LOGGER.logException(err));
    }

    //Potential Countermeasures Code

    let expandedRowsPotential = ref([]);

    let changesDetectedPotential = ref(false);

    let measuresPotential = ref([]);

    const getNewPotential = () => {
      return {
        brkey: waterwayValue.value.brkey,
        inspectionId: waterwayValue.value.inspectionId,
        location: "",
        pcmKey: getNextKey(waterwayValue.value.scourPossCMeasures, "pcmKey"),
        wcKey: "",
      };
    };

    const convertToPotentialObject = (detail) => {
      return {
        brkey: detail.brkey,
        inspectionId: detail.inspectionId,
        location: detail.location,
        pcmKey: detail.pcmKey,
        wcKey: detail.wcKey,
      };
    };

    const getMeasuresPotential = () => {
      expandedRowsPotential.value = [];
      measuresPotential.value = clone(waterwayValue.value.scourPossCMeasures);

      if (!measuresPotential?.value?.[0]) {
        //remove null values from array(if any)
        measuresPotential.value = measuresPotential.value?.filter((a) => !!a);
      }
      sortByTwoProperties(measuresPotential.value, "location", "wcKey");
      for (let idx = 1; idx <= measuresPotential.value?.length; idx++) {
        measuresPotential.value[idx - 1].UNIQUE_KEY = idx;
        measuresPotential.value[idx - 1].readOnly = true;
      }
    };

    const rowClassPotential = (data) => {
      return expandedRowsPotential.value?.find((a) => a.UNIQUE_KEY === data.UNIQUE_KEY) ? "rowSelect" : "rowUnselect";
    };

    const closePotential = () => {
      if (isEditable.value && changesDetectedPotential.value) {
        //show confirmation dialog on closing
        confirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              getMeasuresPotential();
              expandedRowsPotential.value = [];
              changesDetectedPotential.value = false;
              setAddingOrEditing(false);
              snackbarStore.removeMessage(potentialSnackbarId.value);
            }
          });
      } else {
        getMeasuresPotential();
        expandedRowsPotential.value = [];
        setAddingOrEditing(false);
        snackbarStore.removeMessage(potentialSnackbarId.value);
      }
    };

    const isExpandedPotential = (details) => {
      return expandedRowsPotential.value?.findIndex((a) => a.UNIQUE_KEY == details.UNIQUE_KEY) >= 0;
    };

    function editPotential(detail) {
      setAddingOrEditing(true);
      detail.readOnly = false;
      expandedRowsPotential.value = [detail];

      potentialSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.POTENTIAL_COUNTERMEASURES_DATATABLE,
      });
    }

    function deletePotential(detail) {
      confirm.value.open(DELETE_CONFIRM_POTENTIAL, BUTTONS.YES).then((response) => {
        if (response) {
          const deleteIndex = waterwayValue.value.scourPossCMeasures.findIndex((a) => a?.pcmKey === detail.pcmKey);
          if (deleteIndex > -1) {
            waterwayValue.value.scourPossCMeasures.splice(deleteIndex, 1);
            expandedRowsPotential.value = [];
            getMeasuresPotential();
          }
        }
      });
    }

    const anyEditablePotential = computed(() => {
      return expandedRowsPotential.value?.some((element) => !element.readOnly);
    });

    const togglePotentialRow = (detail) => {
      if (expandedRowsPotential.value?.includes(detail)) {
        const index = expandedRowsPotential.value.findIndex((a) => detail.UNIQUE_KEY == a.UNIQUE_KEY);
        expandedRowsPotential.value.splice(index, 1);
      } else {
        expandedRowsPotential.value.push(detail);
      }
    };

    function addPotential() {
      setAddingOrEditing(true);
      potentialSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.POTENTIAL_COUNTERMEASURES_DATATABLE,
      });
      let newPotential = getNewPotential();
      newPotential.isAdd = true;
      newPotential.readOnly = false;
      newPotential.UNIQUE_KEY = getNextKey(measuresPotential.value, "UNIQUE_KEY");
      measuresPotential.value.unshift(newPotential);
      expandedRowsPotential.value = [newPotential];
    }

    function savePotential(detail) {
      if (!waterwayValue.value?.scourPossCMeasures?.[0]) {
        //remove null values from array(if any)
        waterwayValue.value.scourPossCMeasures = waterwayValue.value.scourPossCMeasures?.filter((a) => !!a);
      }
      if (detail.isAdd) {
        waterwayValue.value.scourPossCMeasures.push(convertToPotentialObject(detail));
      } else {
        //update existing
        const updateIndex = waterwayValue.value.scourPossCMeasures.findIndex((a) => a?.pcmKey === detail.pcmKey);
        waterwayValue.value.scourPossCMeasures.splice(updateIndex, 1, convertToPotentialObject(detail));
      }
      //if all required fields entered - close the expanded row
      expandedRowsPotential.value = [];
      getMeasuresPotential();
      changesDetectedPotential.value = false;
      setAddingOrEditing(false);
      snackbarStore.removeMessage(potentialSnackbarId.value);
    }

    //UnderwaterInsp Table Code

    let floodPlainTable = ref(null);

    let floodPlainForm = ref(null);

    let validFloodPlain = ref(false);

    let expandedRowsFloodPlain = ref([]);

    let floodPlains = ref([]);

    const getIsUwRequired = (detail) => {
      if (detail.underwaterInspType == "A" || detail.underwaterInspType == "B" || detail.underwaterInspType == "C") {
        return { isUwRequired: "1" };
      } else {
        return { isUwRequired: "0" };
      }
    };

    const convertToFloodPlainObject = (detail) => {
      return {
        alignment: detail.alignment,
        brkey: detail.brkey,
        calcScourDepth100: detail.calcScourDepth100,
        calcScourDepth500: detail.calcScourDepth500,
        changeSinceLastInsp: detail.changeSinceLastInsp,
        counterMeasure: detail.counterMeasure,
        debrisPotential: detail.debrisPotential,
        foundType: detail.foundType,
        inspectionId: detail.inspectionId,
        invFoundType: detail.invFoundType,
        maxWaterDepth: detail.maxWaterDepth,
        updateDateTime: detail.updateDateTime,
        movement: detail.movement,
        obsScourDepth: detail.obsScourDepth,
        obsScourRating: detail.obsScourRating,
        openAdeqChannel: detail.openAdeqChannel,
        previousCurrent: detail.previousCurrent,
        sar: detail.sar,
        scbiCase: detail.scbiCase,
        scbiCode: detail.scbiCode,
        scourHole: detail.scourHole,
        scourUndermine: detail.scourUndermine,
        sedDeposit: detail.sedDeposit,
        streamBedMaterial: detail.streamBedMaterial,
        strUnitKey: detail.strUnitKey,
        subUnitType: detail.subUnitType,
        subScour: detail.subScour,
        underwaterInspDesc: detail.underwaterInspDesc,
        underwaterInspType: detail.underwaterInspType,
        updateUserId: detail.updateUserId,
        veloStreamSlope: detail.veloStreamSlope,
      };
    };

    const calculateScpoaReqD = () => {
      if (waterwayValue.value.brkey) {
        waterwayValue.value.scpoaReqD = getScourPOA(scourCriticalCategory.value);
      }
    };

    const getFloodPlains = () => {
      expandedRowsFloodPlain.value = [];
      floodPlains.value = clone(waterwayValue.value.inspectionsUnderwater);

      if (!floodPlains.value) {
        //remove null values from array(if any)
        floodPlains.value = floodPlains.value?.filter((a) => !!a);
      }
      if (floodPlains.value) {
        for (let idx = 1; idx <= floodPlains.value.length; idx++) {
          floodPlains.value[idx - 1].UNIQUE_KEY = idx;
          let subLookup = inspectionStore.getSubStructure(
            floodPlains.value[idx - 1]?.strUnitKey,
            waterwayValue.value.structureUnits,
          );
          floodPlains.value[idx - 1].subUnit = subLookup?.strUnitLabel;
          floodPlains.value[idx - 1].legacyStructureType = subLookup?.legacyStructureType;
          floodPlains.value[idx - 1].readOnly = true;
        }
        nextTick(() => {
          floodPlains?.value.sort(floodPlainCustomSort);
        });
      }
    };

    const rowClassFloodPlain = (data) => {
      return expandedRowsFloodPlain.value?.find((a) => a.UNIQUE_KEY === data.UNIQUE_KEY) ? "rowSelect" : "rowUnselect";
    };

    const closeFloodPlain = (detail) => {
      if (isEditable.value && detail.changesDetectedFloodPlain) {
        //show confirmation dialog on closing
        confirm.value
          .open(INSPECTION_MESSAGES.DETECT_DATATABLE_CHANGE_CONFIRMATION_MESSAGE, BUTTONS.YES)
          .then((response) => {
            if (!response) {
              getFloodPlains();
              expandedRowsFloodPlain.value = [];
              detail.changesDetectedFloodPlain = false;
              snackbarStore.removeMessage(floodPlainSnackbarId.value);
              setAddingOrEditing(false);
            }
          });
      } else {
        getFloodPlains();
        expandedRowsFloodPlain.value = [];
        setAddingOrEditing(false);
        snackbarStore.removeMessage(floodPlainSnackbarId.value);
      }
    };

    const isExpandedFloodPlain = (details) => {
      return expandedRowsFloodPlain.value?.findIndex((a) => a.UNIQUE_KEY == details.UNIQUE_KEY) >= 0;
    };

    function editFloodPlain(detail) {
      setAddingOrEditing(true);
      detail.readOnly = false;
      expandedRowsFloodPlain.value = [detail];
      floodPlainSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SUBUNITS_WITHIN_500YR_FLOOD_PLAIN_DATATABLE,
      });
      nextTick(() => {
        floodPlainForm.value?.validate();
      });
    }

    function deleteFloodPlain(detail) {
      confirm.value.open(DELETE_CONFIRM_UNDERWATER_INSP, BUTTONS.YES).then((response) => {
        if (response) {
          const deleteIndex = waterwayValue.value.inspectionsUnderwater.findIndex(
            (a) => a?.strUnitKey === detail?.strUnitKey,
          );
          if (deleteIndex > -1) {
            waterwayValue.value.inspectionsUnderwater.splice(deleteIndex, 1);
            expandedRowsFloodPlain.value = [];
            calculateOnFloodPlainUpdate();
            getFloodPlains();
          }
        }
      });
    }

    const anyEditableFloodPlain = computed(() => {
      return expandedRowsFloodPlain.value?.find((element) => !element.readOnly);
    });

    const toggleFloodPlainsRow = (detail) => {
      if (expandedRowsFloodPlain.value?.includes(detail)) {
        const index = expandedRowsFloodPlain.value.findIndex((a) => detail.UNIQUE_KEY == a.UNIQUE_KEY);
        expandedRowsFloodPlain.value.splice(index, 1);
      } else {
        expandedRowsFloodPlain.value.push(detail);
      }
    };

    function addFloodPlain() {
      setAddingOrEditing(true);
      floodPlainSnackbarId.value = snackbarStore.showMessage({
        displayText: INSPECTION_MESSAGES.SUBUNITS_WITHIN_500YR_FLOOD_PLAIN_DATATABLE,
      });
      let newFloodPlain = clone(UNDERWATER_INSP);
      newFloodPlain.brkey = waterwayValue.value.brkey;
      newFloodPlain.inspectionId = waterwayValue.value.inspectionId;
      newFloodPlain.updateDateTime = waterwayValue.value.updateDateTime;
      newFloodPlain.movement = "0";
      newFloodPlain.updateUserId = waterwayValue.value.updateUserId;
      newFloodPlain.isAdd = true;
      newFloodPlain.readOnly = false;
      newFloodPlain.UNIQUE_KEY = getNextKey(floodPlains.value, "UNIQUE_KEY");
      floodPlains.value.unshift(newFloodPlain);
      expandedRowsFloodPlain.value = [newFloodPlain];
      newFloodPlain.changesDetectedFloodPlain = true;
      nextTick(() => {
        floodPlainForm.value?.validate();
        floodPlainTable.value.d_sortOrder = 1;
        floodPlainTable.value.d_sortField = "subUnit";
      });
    }

    function saveFloodPlain(detail) {
      floodPlainForm.value
        .validate()
        .then(() => {
          if (validFloodPlain.value) {
            validationSnackbar.value = false;
            snackbarStore.removeMessage(floodPlainSnackbarId.value);
            if (!waterwayValue.value?.inspectionsUnderwater?.[0]) {
              //remove null values from array(if any)
              waterwayValue.value.inspectionsUnderwater = waterwayValue.value.inspectionsUnderwater?.filter((a) => !!a);
            }
            if (detail.isAdd) {
              waterwayValue.value.inspectionsUnderwater?.push(convertToFloodPlainObject(detail));
            } else {
              //update existing
              const updateIndex = waterwayValue.value.inspectionsUnderwater.findIndex(
                (a) => a?.strUnitKey === detail.strUnitKey,
              );
              waterwayValue.value.inspectionsUnderwater?.splice(updateIndex, 1, convertToFloodPlainObject(detail));
            }
            //if all required fields entered - close the expanded row
            expandedRowsFloodPlain.value = [];
            if (detail.changesDetectedFloodPlain) {
              calculateOnFloodPlainUpdate();
              detail.changesDetectedFloodPlain = false;
            }
            getFloodPlains();
            setAddingOrEditing(false);
          } else {
            validationSnackbar.value = true;
          }
        })
        .catch((err) => LOGGER.logException(err));
    }

    const setUpdatedComment = (comment, commentType) => {
      const foundComment = waterwayValue.value.inspectionComments.find((c) => {
        return c.commentType === commentType;
      });
      if (foundComment) {
        foundComment.notes = comment.notes;
      } else {
        waterwayValue.value.inspectionComments.push(comment);
      }
    };

    //Channel and Waterway Adequacy Information Code

    const channelRating = computed({
      get() {
        return waterwayValue.value?.chanRating;
      },
      set(channelRatingParam) {
        waterwayValue.value.chanRating = channelRatingParam;
      },
    });
    const waterwayRating = computed({
      get() {
        return waterwayValue.value?.wateradeq;
      },
      set(waterwayRatingParam) {
        waterwayValue.value.wateradeq = waterwayRatingParam;
      },
    });

    const riskOfOvertopping = computed({
      get() {
        return waterwayValue.value?.overTopRisk;
      },
      set(riskOfOvertoppingParam) {
        waterwayValue.value.overTopRisk = riskOfOvertoppingParam;
      },
    });

    const trafficDelay = computed({
      get() {
        return waterwayValue.value?.trafficDelay;
      },
      set(trafficDelayParam) {
        waterwayValue.value.trafficDelay = trafficDelayParam;
      },
    });

    const worstFloodEvent = computed({
      get() {
        return waterwayValue.value?.overTopping;
      },
      set(worstFloodEventParam) {
        waterwayValue.value.overTopping = worstFloodEventParam;
      },
    });

    const worstFloodEventDate = computed({
      get() {
        return waterwayValue.value?.overtopDate;
      },
      set(worstFloodEventDateParam) {
        waterwayValue.value.overtopDate = worstFloodEventDateParam;
      },
    });

    const functionClass = computed({
      get() {
        return waterwayValue.value.functionClass;
      },
    });

    const elevationOfWaterLevel = computed({
      get() {
        return waterwayValue.value?.highWaterElev;
      },
      set(elevationOfWaterLevelParam) {
        waterwayValue.value.highWaterElev = elevationOfWaterLevelParam;
      },
    });

    const highWaterDate = computed({
      get() {
        return waterwayValue.value?.highWaterDate;
      },
      set(highWaterDateParam) {
        waterwayValue.value.highWaterDate = highWaterDateParam;
      },
    });

    const newHighWaterMark = computed({
      get() {
        return waterwayValue.value?.newHighWater;
      },
      set(newHighWaterMarkParam) {
        waterwayValue.value.newHighWater = newHighWaterMarkParam;
      },
    });

    let subScourRating = computed({
      get() {
        let obsScourRatings = [];
        if (waterwayValue.value?.inspectionsUnderwater) {
          for (let underwaterInspection of waterwayValue.value.inspectionsUnderwater) {
            obsScourRatings.push(Number.parseInt(underwaterInspection?.obsScourRating));
          }
        }

        if (obsScourRatings == []) {
          return -1;
        } else {
          return Math.min(...obsScourRatings);
        }
      },
    });

    function calculateScourCriticalCategory() {
      if (subScourRating.value == -1) {
        waterwayValue.value.scourCriticalCat = "--";
      } else if (
        Number.parseInt(waterwayValue.value?.scourCritical) <= 2 ||
        Number.parseInt(waterwayValue.value?.scourCritical) == 6 ||
        subScourRating.value <= 3
      ) {
        waterwayValue.value.scourCriticalCat = "A";
      } else if (Number.parseInt(waterwayValue.value?.scourCritical) == 3 && subScourRating.value == 4) {
        waterwayValue.value.scourCriticalCat = "B";
      } else if (
        Number.parseInt(waterwayValue.value?.scourCritical) == 3 &&
        subScourRating.value <= 9 &&
        subScourRating.value >= 5
      ) {
        waterwayValue.value.scourCriticalCat = "C";
      } else if (
        Number.parseInt(waterwayValue.value?.scourCritical) == 4 ||
        Number.parseInt(waterwayValue.value?.scourCritical) == 7
      ) {
        waterwayValue.value.scourCriticalCat = "D";
      } else {
        waterwayValue.value.scourCriticalCat = "--";
      }
    }

    function calculateOverallSCBI() {
      configStore.getScourCriticalBridgeIndicator(waterwayValue.value);
    }

    const showCalculate = computed({
      get() {
        if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
          return inspectionLinksStore.showCalculate;
        } else {
          return inspectionStore.getShowCalculate;
        }
      },
      set(value) {
        if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
          inspectionLinksStore.showCalculate = value;
        } else {
          inspectionStore.setShowCalculate(value);
        }
      },
    });

    function calculate() {
      if (!waterwayValue.value?.scourCalculated || waterwayValue.value?.scourCalculated == "0") {
        waterwayValue.value.scourCalculated = "1";
      }
      calculateOverallSCBI();
      calculateScourCriticalCategory();
      if (expandedRowsFloodPlain.value.length == 0) {
        getFloodPlains();
      }
      calculateScpoaReqD();
      inspectionStore.setSaved(false);
      showCalculate.value = true;
      inspectionStore.setSavingSnackbar(true);
    }

    function calculateOnSave() {
      if (waterwayValue.value?.scourCalculated == "1") {
        calculateOverallSCBI();
        calculateScourCriticalCategory();
        if (expandedRowsFloodPlain.value.length == 0) {
          getFloodPlains();
        }
        calculateScpoaReqD();
        showCalculate.value = true;
      }
    }

    function calculateOnFloodPlainUpdate() {
      if (waterwayValue.value?.scourCalculated == "1") {
        calculateOverallSCBI();
        calculateScourCriticalCategory();
        if (expandedRowsFloodPlain.value.length == 0) {
          getFloodPlains();
        }
        inspectionStore.setSaved(false);
        inspectionStore.setSavingSnackbar(true);
        showCalculate.value = true;
      }
    }

    //Validation

    async function validate() {
      await modifyWaterwayConditions.value.validate();
      await modifyWaterwayDetails.value.validate();
      await modifyChannelAndWaterwayAdequacyInfo.value.validate();
      if (validWaterwayConditions.value && validWaterwayDetails.value && validChannelAndWaterwayAdequacyInfo.value) {
        valid.value = true;
      } else {
        valid.value = false;
      }
    }

    const checkCurrentScourValidation = (value) => {
      //add validation only when the expansion panel is expanded(value = true)
      if (value) {
        nextTick(() => {
          currentForm.value?.validate();
        });
      }
    };

    const resetChangedByUser = async () => {
      underwaterChangedByUser.value = false;
      inspectionStore.setOverallScourHoleChangedByUser(false);
    };

    const checkFloodPlainFormValidation = (value) => {
      //add validation only when the expansion panel is expanded(value = true)
      if (value) {
        nextTick(() => {
          floodPlainForm.value?.validate();
        });
      }
    };
    let channelConditionUpdated = ref(false);
    let conditionUpdated = ref(false);
    let scbiUpdated = ref(false);
    const updateDuration = () => {
      if (scbiUpdated.value) {
        waterwayValue.value.scourCriticalDurationChanges = inspectionStore.setDurationChanges(
          waterwayValue.value.scourCriticalDurationChanges,
        );
        waterwayValue.value.scourCriticalDuration = inspectionStore.setDuration(
          waterwayValue.value.scourCriticalDuration,
          waterwayValue.value.scourCriticalDurationChanges,
        );
      }
      if (channelConditionUpdated.value) {
        waterwayValue.value.chanRatingDurationChanges = inspectionStore.setDurationChanges(
          waterwayValue.value.chanRatingDurationChanges,
        );
        waterwayValue.value.chanRatingDuration = inspectionStore.setDuration(
          waterwayValue.value.chanRatingDuration,
          waterwayValue.value.chanRatingDurationChanges,
        );
      }
      channelConditionUpdated.value = false;
      scbiUpdated.value = false;
      conditionUpdated.value = false;
    };
    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panels.value = allPanels;
      } else {
        panels.value = [];
      }
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Waterway-Screen", marker: SNACKBAR_MARKER.WATERWAY };
    };

    const saveChanges = async () => {
      const structure = inspectionStore.selectedInspection;
      const isSuccess = await waterwayStore.saveData(props.moduleType, waterwayValue.value, structure);
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        await readData();
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      inspectionLinksStore.isDirty = false;
      await readData();
      await validate();
    };

    watch(
      () => [waterwayValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    return {
      isEditableForAnyServTypUnd,
      lessThanValueRule,
      valueInRangeRule,
      MODULE_TYPES,
      setUpdatedComment,
      pierProtection,
      saveChanges,
      cancelChanges,
      readData,
      waterwayValue,
      printD491,
      validChannelAndWaterwayAdequacyInfo,
      modifyChannelAndWaterwayAdequacyInfo,
      calculateOnSave,
      getMeasuresCurrent,
      getMeasuresPotential,
      getFloodPlains,
      calculateScpoaReqD,
      scbiUpdated,
      channelConditionUpdated,
      conditionUpdated,
      updateDuration,
      resetChangedByUser,
      underwaterChangedByUser,
      modifyWaterwayDetails,
      validWaterwayDetails,
      getSortIcon,
      sortByFloodPlain,
      toggleFloodPlainsRow,
      togglePotentialRow,
      toggleCurrentRow,
      streambedMaterialMaxLength,
      cMeasureLocations,
      getPierAbutTypes,
      floodPlainTable,
      calculateOverallSCBI,
      getIsUwRequired,
      calculateScourCriticalCategory,
      newHighWaterMark,
      highWaterDate,
      elevationOfWaterLevel,
      getHistDuration,
      functionClass,
      worstFloodEventDate,
      worstFloodEvent,
      trafficDelay,
      riskOfOvertopping,
      waterwayRating,
      channelProtectionRating,
      ROUNDING_FACTOR,
      channelRating,
      validFloodPlain,
      floodPlainForm,
      inspectionStore,
      saveFloodPlain,
      deleteFloodPlain,
      closeFloodPlain,
      editFloodPlain,
      isExpandedFloodPlain,
      anyEditableFloodPlain,
      rowClassFloodPlain,
      onRowExpand,
      floodPlains,
      addFloodPlain,
      expandedRowsFloodPlain,
      changesDetectedPotential,
      getNewPotential,
      savePotential,
      deletePotential,
      closePotential,
      editPotential,
      isExpandedPotential,
      anyEditablePotential,
      rowClassPotential,
      measuresPotential,
      addPotential,
      expandedRowsPotential,
      confirm,
      changesDetectedCurrent,
      getNewCurrent,
      subUnits,
      configStore,
      validCurrent,
      currentForm,
      saveCurrent,
      deleteCurrent,
      BUTTONS,
      closeCurrent,
      editCurrent,
      isExpandedCurrent,
      anyEditableCurrent,
      rowClassCurrent,
      measuresCurrent,
      addCurrent,
      expandedRowsCurrent,
      rightCondition,
      rightPresence,
      leftCondition,
      leftPresence,
      nabLoaction,
      fabLoaction,
      vertDebrisEnd,
      vertDebrisStart,
      horizDebrisEnd,
      horizDebrisStart,
      numberOfSubunits,
      streamBedMaterialDescription,
      streamBedMaterialTwo,
      streamBedMaterialOne,
      channel,
      scourCalculated,
      overallScbi,
      scbiSource,
      scourCriticalCategory,
      scourCritical,
      scourVulnerability,
      overallScourHole,
      underwater,
      calculate,
      modifyWaterwayConditions,
      valid,
      validWaterwayConditions,
      validate,
      REFERENCE_TABLE,
      panels,
      isEditable,
      structure,
      commentsMaxLength,
      INSPECTION_COMMENTS,
      checkCurrentScourValidation,
      checkFloodPlainFormValidation,
      toggleAllPanels,
    };
  },
  components: {
    ManagementCommentTypeTextField,
    DataTableHeader,
    IconTooltip,
    LabelCheckbox,
    LabelText,
    LabelSelect,
    CommentTypeTextField,
    ConfirmDialog,
    LabelDatefield,
    ExpandCollapseToggle,
    ValidationCountsHeader,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

.v-expansion-panel-title__icon {
  order: 0;
}

.tableHeader {
  text-align: center !important;
  background: c.$p-pa-light-blue !important;
}

.v-label.v-field-label {
  color: c.$p-black !important;
  opacity: 1 !important;
  font-weight: bold !important;
}
.alignCenter {
  text-align: center;
}
.alignEnd {
  text-align: end;
}
.v-data-table :deep(button:hover) {
  background-color: inherit !important;
  color: inherit !important;
}

.v-data-table :deep(button:focus) {
  outline: none !important;
}
</style>
